module.exports = __webpack_public_path__ + "img/region_southeast.fcdc5eaf.svg";